import { createFileRoute, redirect } from "@tanstack/react-router"

// Sign-in landing. Drop-in Review is the deliberate default: it is a LIVE screen with real work
// queued on it, whereas the previous landing (/operations/approvals) is still seed-backed and
// carries `demo: true` — so a fresh sign-in opened on a demo screen. Keep this in step with the
// Operations mode's `defaultPanelId` in data/navigation.ts; they answer the same question for two
// different entry points (URL root vs clicking the mode).
/**
 * @interop TanStack Router redirects only when beforeLoad throws a redirect().
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/operations/dropin" })
  },
})
